import { useEffect } from 'react';
import CampaignList from '../CampaignList';
import { useNavigate, useLocation } from 'react-router-dom';
import { useMessages } from '../../contexts/messages';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '../Breadcrumb/index';

const Campaign = () => {
  const { fetchSegments, fetchAllFish, fetchMergeTags } = useMessages();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    fetchSegments();
    fetchAllFish();
    fetchMergeTags('FISH');
  }, []);

  return (
    <div className="">
      <div className="font-questrial mb-4 flex items-center">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem
              onClick={() => {
                navigate('/dashboard');
              }}
              className={`cursor-pointer ${pathname !== '/dashboard' && 'opacity-50'}`}
            >
              Dashboard
            </BreadcrumbItem>
            <BreadcrumbSeparator></BreadcrumbSeparator>
            <BreadcrumbItem
              className={`cursor-pointer ${!pathname.includes('/campaigns') && 'opacity-50'}`}
            >
              Campaigns
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>

      <div className="mb-4 flex items-center justify-between">
        <div>
          <h1 className="mb-2 text-2xl font-bold">Campaigns</h1>
        </div>
      </div>

      <div className="pb-10">
        <CampaignList />
      </div>
    </div>
  );
};

export default Campaign;
